import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";


const ChatBox = () => {

  const lang = localStorage.getItem("lang")
  const { settingInfo, loading } = useSelector(({ Settings }) => Settings);


 /**
     * Used for render the chatBox UI
     */
  useEffect(() => {


    var Tawk_API = Tawk_API || {};
    var Tawk_LoadStart = new Date();

    switch (lang) {
      case "ar":
        var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
        (function(){
        var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
        s1.async=true;
        s1.src = 'https://embed.tawk.to/' + settingInfo?.tawkToKeys?.propertyIdar + "/" + settingInfo?.tawkToKeys?.widgetIdar;
        s1.charset='UTF-8';
        s1.setAttribute('crossorigin','*');
        s0.parentNode.insertBefore(s1,s0);
        })();
      
        break;

      default:
        var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
        (function(){
        var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
        s1.async=true;
        s1.src = 'https://embed.tawk.to/' + settingInfo?.tawkToKeys?.propertyIden + "/" + settingInfo?.tawkToKeys?.widgetIden;
        s1.charset='UTF-8';
        s1.setAttribute('crossorigin','*');
        s0.parentNode.insertBefore(s1,s0);
        })();
        break;
    }
  }, []);



  return (
    <div className="App">

    </div>
  );
}

export default ChatBox;